import * as React from "react"

import Svg, { Circle, Path } from "react-native-svg"

const EntityErrorIcon = (props) => (
  <Svg
    viewBox="0 0 32 32"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    overflow="visible"
    {...props}
  >
    <Circle cx={16} cy={16} r={16} fill="#ff667a" className="fill-d72828" />
    <Path
      d="M14.5 25h3v-3h-3v3zm0-19v13h3V6h-3z"
      fill="#e6e6e6"
      className="fill-e6e6e6"
    />
  </Svg>
)

export default EntityErrorIcon
